// extracted by mini-css-extract-plugin
module.exports =  {"menu-container":"owi1PGU","menuContainer":"owi1PGU"};